<div class="flex flex-col">
  <div mat-dialog-title class="!m-0 border-b border-gray-200 px-6 !pt-0 pb-5">
    <h2 class="text-xl font-semibold text-gray-900">Edit Payout Account</h2>
    <p class="mt-1 text-sm text-gray-600">Update your payout account details</p>
  </div>

  <div mat-dialog-content class="!px-6 !py-6">
    <div class="flex flex-col gap-6">
      <!-- Warning Message -->
      <div class="rounded-lg border border-yellow-200 bg-yellow-50 p-4">
        <div class="flex gap-3">
          <dojo-icon [icon]="'triangle-exclamation'" [size]="16" class="mt-0.5 text-yellow-600" />
          <div class="flex-1">
            <h3 class="text-sm font-medium text-yellow-800">Important Notice</h3>
            <p class="mt-1 text-sm text-yellow-700">
              Changing your email will update your payout account. All future payouts will be sent to the new email
              address. This change will not affect any payouts that have already been requested.
            </p>
          </div>
        </div>
      </div>

      <!-- Form -->
      <form [formGroup]="form" class="space-y-5">
        <!-- Email Field -->
        <div>
          <label class="mb-2 block text-sm font-medium text-gray-700">Recipient Email Address</label>
          <dojo-text-input
            [formCtrl]="form.controls.email"
            type="email"
            placeholder="Enter email address"
            autocomplete="email"
          />
        </div>

        <!-- Name Field -->
        <div>
          <label class="mb-2 block text-sm font-medium text-gray-700">Recipient Name</label>
          <dojo-text-input
            [formCtrl]="form.controls.name"
            type="text"
            placeholder="Enter recipient name"
            autocomplete="name"
          />
        </div>

        <!-- Currency Field -->
        <div>
          <label class="mb-2 block text-sm font-medium text-gray-700">Currency</label>
          <dojo-single-select
            [formCtrl]="form.controls.currency"
            [options]="state.currencies"
            [optionValue]="'code'"
            [optionLabel]="'name'"
            placeholder="Select currency"
          />
        </div>
      </form>
    </div>
  </div>

  <div mat-dialog-actions class="!m-0 border-t-2 border-gray-200 px-6 py-5">
    <div class="flex w-full gap-3">
      <dojo-button [fill]="'outline'" (click)="cancel()" class="flex-1"> Cancel </dojo-button>
      <dojo-button [fill]="'solid'" [disabled]="!form.valid" (click)="confirm()" class="flex-1">
        Update Account
      </dojo-button>
    </div>
  </div>
</div>
